module.exports = __webpack_public_path__ + "img/zhxy-1.1375267e.png";